export default __webpack_public_path__ + "static/media/card-front-square.add2c7ec.jpg";